import { create } from 'apisauce';
import { api as apApi } from './index';

export const getExternalCalendars = async () => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get('/api/integrations/calendars');
};

export const addLoginCalendar = async ({ integrationId, calendarsId }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post(`api/login_calendars/integrations/${integrationId}`, { calendars_id: calendarsId });
};

export const deleteLoginCalendar = async (id) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.delete(`/api/login_calendars/${id}`);
};

export const syncLoginCalendars = async (integrationId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.put(`api/login_calendars/integrations/${integrationId}`, {});
};

export const unsyncLoginCalendars = async (integrationId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.delete(`api/login_calendars/integrations/${integrationId}`, {});
};

export const getSyncedWeddings = async () => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/current_login/integrations_sync_weddings`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get();
};

export const toggleCalendarExternalSync = async ({ weddingId, loginId, checked }) => {
  const q = checked ? 'integrations_sync_enabled' : 'integrations_sync_enabled=false';
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${weddingId}/logins/${loginId}/self?${q}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', { integrations_sync_enabled: checked });
};

export const createExternalBookedLeadsEvents = async () => {
  return apApi.post('/api/integrations/calendars/booked-calendar/leads/add', {});
};

export const deleteExternalBookedLeadsEvents = async () => {
  return apApi.post('/api/integrations/calendars/booked-calendar/leads/delete', {});
};
